module.exports = __webpack_public_path__ + "static/media/sf-test-2.0678eb76.mp3";